export { default } from './AndroidSplashOverlay';
export * from './AndroidSplashOverlay';
